export default __webpack_public_path__ + "static/media/sound-off.2e9e21c1.svg";